import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend); // Register required components

const DonutChart = ({dataInCard}) => {
  const labels = ['Vacant Houses', 'Occupied Houses','Total Houses']; // Separate labels array
  const dataValues = [  dataInCard?.vacantHouses,dataInCard?.occupiedHouses]; // Separate data array

  const data = {
    datasets: [
      {
        label: 'Housing Data',
        data: dataValues, // Reference the data values
        backgroundColor: [ '#B39359','#0B2C3C', '#99ff99'], // Section colors
        hoverOffset: 4,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    cutout: '60%', // Donut hole size
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true, // Enable tooltips
        callbacks: {
          label: function(tooltipItem) {
            const index = tooltipItem.dataIndex; // Get the index of the hovered section
            const label = labels[index]; // Use the separate labels array
            const value = tooltipItem.raw; // Get the value for that section
            return `${label}: ${value}`; // Format the tooltip label
          }
        }
      },
      legend: {
        position: 'bottom', // Place legend at the bottom
        labels: {
          font: {
            size: 14, // Legend font size
          },
        },
      },
    },
    onClick: (e, elements) => {
      if (elements.length > 0) {
        const element = elements[0]; // Get clicked element
        const index = element.index; // Get the index of clicked section
        const label = labels[index]; // Get label based on index from the separate labels array
        const value = dataValues[index]; // Get value based on index from the separate data array
        // alert(`You clicked on ${label}: ${value}`); // Display label and value on click
      }
    },
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DonutChart;
